import * as types from './action-types';
import services from '../../../../services';

const { coreAPIInstance: api } = services;

const submitLeadComplete = (leadData) => ({
    asyncAction: (dispatch, getState) => {
        const state = getState();

        // Check if we're in web-ui (authenticated environment)
        if (state && state.loan && state.loan.loanJson && state.loan.loanJson.loanId) {
            // Use authenticated endpoint
            return api.leadCompleteAuthenticated(leadData, state.loan.loanJson.loanId);
        } else {
            // Use unauthenticated endpoint
            return api.leadComplete(leadData);
        }
    },
    type: types.LEAD_COMPLETE
});

export default {
    submitLeadComplete
};
